import { Client } from '@twilio/conversations';

export abstract class TwilioClientAccessService {
  public abstract getTwilioClient(): Client;
}
